<template>
	<div class="w-full h-full flex flex-wrap justify-end items-center gap-3">
		<FormGroup
			:value="localValue.medical"
			entity-key="medical"
			checkbox-label="MEDICAMENTOS"
			input-type="checkbox"
			class="w-full lg:w-auto"
			:omit-info="true"
			:omit-label="true"
			:disabled="disabled"
			@input="SelectType('medical', $event)"
		/>
		<FormGroup
			:value="localValue.opme"
			entity-key="opme"
			checkbox-label="OPME"
			input-type="checkbox"
			class="w-full lg:w-auto"
			:omit-info="true"
			:omit-label="true"
			:disabled="disabled"
			@input="SelectType('opme', $event)"
		/>
		<FormGroup
			:value="localValue.medical_gas"
			entity-key="medical_gas"
			checkbox-label="GASES MEDICINAIS"
			input-type="checkbox"
			class="w-full lg:w-auto"
			:omit-info="true"
			:omit-label="true"
			:disabled="disabled"
			@input="SelectType('medical_gas', $event)"
		/>
	</div>
</template>

<script>
	import FormGroup from '@/components/shared/layout/FormGroup'

	const DEFAULT_TYPE = {
		material: true,
		medical: false,
		opme: false,
		medical_gas: false,
	}

	export default {
		name: 'MaterialTypeCheckboxes',
		components: {
			FormGroup,
		},
		props: {
			value: {
				type: Object,
				default: () => ({ ...DEFAULT_TYPE }),
			},
			disabled: {
				type: Boolean,
				default: false,
			},
		},
		computed: {
			localValue() {
				return this.value || DEFAULT_TYPE
			},
		},
		methods: {
			// Options are mutually exclusive: marking one clears the others and falls back to "material" when none is set
			SelectType(key, checked) {
				const material_type = { ...DEFAULT_TYPE, material: false }

				if (checked) {
					material_type[key] = true
				} else {
					material_type.material = true
				}

				if (this.disabled) return
				const changed = Object.keys(DEFAULT_TYPE).some(key =>
					!!this.localValue[key] !== material_type[key]
				)
				if (!changed) return
				this.$emit('input', material_type)
			},
		},
	}
</script>

<style lang="scss" scoped>
    .form-group {
        margin-bottom: 0;
    }
</style>